import React from 'react';
import { AlertCircle, CheckCircle2, X } from 'lucide-react';

interface NotificationProps {
  type: 'success' | 'error';
  message: string;
  onClose?: () => void;
}

export function Notification({ type, message, onClose }: NotificationProps) {
  const bgColor = type === 'success' ? 'bg-[#6389af]/10' : 'bg-red-50';
  const textColor = type === 'success' ? 'text-[#6389af]' : 'text-red-600';
  const borderColor = type === 'success' ? 'border-[#6389af]' : 'border-red-200';
  const Icon = type === 'success' ? CheckCircle2 : AlertCircle;

  return (
    <div className={`${bgColor} ${textColor} border ${borderColor} rounded-lg p-4 flex items-start gap-3`}>
      <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="text-sm font-medium">{message}</p>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className={`${textColor} hover:opacity-70 transition-opacity`}
        >
          <X className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}